import toastr from '@/lib/notifications'
import $ from 'jquery'
import store from '../state/store'

store.on('placement_managers:index', function() {
  $.ajax({
    url: '/api/sales/placement_managers',
    type: 'GET',
    dataType: 'json',
    contentType: 'application/json',
    success: (data) => {
      return store.get().ui.request_placement.set({placement_managers: data.items})
    },
    error: (data) => {
      return toastr.error(
        (data && data.responseJSON && data.responseJSON.custom_error_message) || 'Could not load placement managers'
      )
    }
  })
})
